import { useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { MyContext } from '../MyContext';
import { Box, CssBaseline, Paper, BottomNavigation, BottomNavigationAction } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LogoutIcon from '@mui/icons-material/Logout';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

function LayoutWithBottomNav(){
    const navigate = useNavigate();
    const location = useLocation();
    const { setIsAuthenticated, auth } = useContext(MyContext);
    const [mostraMenu, setMostraMenu] = useState(false);

    const getAuth = ()=>{
        const data = localStorage.getItem('userAuth');

        if(data != null){
            let user = JSON.parse(data);

            if(user.tipo === 'A' || user.tipo === 'M'){
                setMostraMenu(true);
            }
        }
    };
    
    useEffect(() => {
        getAuth();
    }, []);

    const paths = ['/clientes', '/checkout', '/pedidos', '/img_produtos', '/perfil'];
    const currentIndex = paths.indexOf(location.pathname);

    const colorIconBottom = (path) => {
        let iconColor = '#7E7E7E';
        const matchedPath = location.pathname.includes(path);

        if (matchedPath) {
            iconColor = '#237CD4';
        }

        return iconColor;
    };

    const handleLogout = () => {
        localStorage.removeItem('empresa');
        localStorage.removeItem('clienteSelecionado');
        localStorage.removeItem('carrinhoProdutos');
        localStorage.removeItem('userAuth');
        localStorage.removeItem('logged');

        setIsAuthenticated(false);
        navigate('/');
        
        window.location.reload();
    };

    useEffect(()=>{
        colorIconBottom();
    }, [currentIndex]);

    return (
        <Box sx={{ pb: 7, minHeight: '100vh' }}>
            <CssBaseline />

            <Box sx={{ px: 2, pt: 2 }}>
                <Outlet />
            </Box>

            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 99, }} elevation={3}>
                <BottomNavigation
                    showLabels
                    value={currentIndex}
                    onChange={(event, newValue) => navigate(paths[newValue])}
                    sx={{
                        overflowX: 'auto',
                        whiteSpace: 'nowrap',
                        display: 'flex',
                        justifyContent: 'flex-start' // evita que os itens fiquem centralizados
                    }}
                >
                    <BottomNavigationAction label="Clientes" icon={<PeopleIcon />} sx={{ color: colorIconBottom('/clientes') }} />
                    <BottomNavigationAction label="Carrinho" icon={<ShoppingCartIcon />} sx={{ color: colorIconBottom('/checkout') }} />
                    <BottomNavigationAction label="Pedidos" icon={<MonetizationOnIcon />} sx={{ color: colorIconBottom('/pedidos') }} />
                    {
                        (mostraMenu) &&
                        <BottomNavigationAction label="Produtos" icon={<CameraAltIcon />} sx={{ color: colorIconBottom('/img_produtos') }} />
                    }
                    <BottomNavigationAction label="Perfil" icon={<PersonAddIcon />} sx={{ color: colorIconBottom('/perfil') }} />
                    <BottomNavigationAction label="Sair" icon={<LogoutIcon /> } onClick={handleLogout} sx={{ color: '#DA0C16' }} />
                </BottomNavigation>
            </Paper>
        </Box>
    );
}

export default LayoutWithBottomNav;